import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { keyframes } from 'styled-components';

var _templateObject, _templateObject2;
var spin = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var SpinContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  animation: ", " ", " linear infinite;\n"])), spin, function (_ref) {
  var $duration = _ref.$duration;
  return "".concat($duration, "s");
});
var SpinContainer$1 = SpinContainer;

export { SpinContainer$1 as default };
//# sourceMappingURL=Spin.styles.js.map
